import * as React from 'react'
import Modal from '../ui/Modal'
import ExportForm from './ExportForm'

interface IExportForm {
  filter: string
  onClose: () => void
}

class ExportModal extends React.Component<any> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <div className='font-small weight-300 font-grey2 mb2'>EXPORT</div>
            <div>
              <ExportForm filter={this.props.filter} onClose={this.props.onClose} />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ExportModal



// WEBPACK FOOTER //
// ./src/components/trips/ExportModal.tsx